import { setup } from 'xstate';
import { PanelMachineEvent } from './panelMachine.types';

const panelMachineSetup = setup({
    types: {
        context: {},
        events: {} as PanelMachineEvent,
    },
});

export const panelMachine = panelMachineSetup.createMachine({
    id: 'panel',
    initial: 'closed',
    context: {},
    states: {
        closed: {
            on: {
                OPEN: 'open',
            },
        },
        open: {
            initial: 'sidebarNone',
            on: {
                CLOSE: 'closed',
            },
            states: {
                sidebarNone: {
                    on: {
                        TOGGLE_HISTORY_SIDEBAR: 'sidebarHistory',
                    },
                },
                sidebarHistory: {
                    on: {
                        TOGGLE_HISTORY_SIDEBAR: 'sidebarNone',
                        CLOSE_SIDEBAR: 'sidebarNone',
                    },
                },
            },
        },
    },
});

export type PanelMachine = typeof panelMachine;
